import React, { useState } from 'react';
import { Form, AutoComplete } from 'antd';
import { ICountryOrState, IUserAddressRulesField } from 'base/interfaces/address';
import { getFormItemRules } from '@base/account/address/utils';
import { countryRule } from '@base/account/address/const';
import { RuleObject } from 'antd/lib/form';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    zipCodeList: string[];
    itemRules: IUserAddressRulesField;
    currentCountryObj?: ICountryOrState;
}

const CountryFormItem: React.FC<IProps> = (props) => {
    const {
        zipCodeList,
        itemRules,
        currentCountryObj,
    } = props;

    const [zipCodeAttr, setZipCodeAttr] = useState<{
        isOpen?: boolean;       // 显示选项
        isFilter?: boolean;     // 是否筛选
    }>({
        isOpen: false,
        isFilter: false,
    })
    
    const {
        key,
        labelTitle,
        placeholder = ' ',
    } = itemRules;

    const { t } = useTrans();

    const _provinceCode = currentCountryObj?.code || 'US'

    return (
        <Form.Item
            label={labelTitle}
            name={key}
            rules={[
                ...getFormItemRules(itemRules),
                {
                    validator: async (rule: RuleObject, value: string) => {
                        value = value?.toLowerCase()?.replaceAll(' ', '');
                        let reg = countryRule[_provinceCode]?.zipCode
                        const isPass = !value || !reg || reg.test(value)
                        return isPass
                            ? Promise.resolve()
                            : Promise.reject(new Error(t('web_address_zipcode_unvalid_error')))
                    }
                }
            ]}
        >
            <AutoComplete
                allowClear
                placeholder={placeholder}
                open={zipCodeAttr.isOpen}
                onChange={() => {
                    setZipCodeAttr({
                        ...zipCodeAttr,
                        isFilter: true,
                    })
                }}
                onFocus={() => {
                    setZipCodeAttr({
                        ...zipCodeAttr,
                        isOpen: true,
                    })
                }}
                onBlur={() => {
                    setZipCodeAttr({
                        isOpen: false,
                        isFilter: false,
                    })
                }}
                onSelect={() => document?.getElementById(key)?.blur()}
                filterOption={zipCodeAttr.isFilter}
                getPopupContainer={trigger => trigger.parentElement}
                options={zipCodeList.map((zItem: any) => {
                    return {
                        value: zItem,
                        label: zItem,
                    }
                })}
            />
        </Form.Item>
    );
};

export default CountryFormItem